import Echo from "laravel-echo"

require("./vendor/cookie-consent/cookie-consent.js")

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: "07e30bd03360b0bfe9e8",
    cluster: "eu",
    // wsHost: "6001-ovform-ovform-ir9hjxn08zk.ws-eu46.gitpod.io",
    // wsPort: 6001,
    forceTLS: false,
    disableStats: true,
    disabledTransports: ['sockjs', 'xhr_streaming']
});
